module.exports = __webpack_public_path__ + "img/dummypng.e04cc26f.png";